export const filterListByBusinessUnit = (list, businessUnit) => {
  if (businessUnit === 1 || businessUnit === 2) {
    return list.filter((value) => value.businessUnit === businessUnit);
  } else throw new Error("Business Unit must be 1 or 2");
};
